export const File = globalThis.File
export const Blob = globalThis.Blob
